import FlumpObject from "../../general/objects/FlumpObject";

export default class TimeoutGlow extends FlumpObject
{
    show()
    {
        this.visible = true;
        this.display.play({clip: this.keys.idle, looping: 2, callback:{listener:this.hide, context: this}, restart: true});
    }

    hide()
    {
        this.visible = false;
    }
}
